// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__tvTKv","close":"style_close__nesCi"};